






















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Timestamp, XvOrdersResp_Order } from '@/apiv3/index'
import helpers from '@/helpers'

@Component
export default class Calculator extends Vue {
  @Prop() order!: XvOrdersResp_Order

  public size (val: string): number {
    const re = RegExp('(\\d+)')
    if (!re.test(val)) {
      return 0
    }

    const res = re.exec(val)
    if (res === null || res.length === 0) {
      return 0
    }

    const size = Number.parseInt(res[0], 10)
    if (Number.isNaN(size)) {
      return 0
    }

    return size
  }

  public delta (finishDate: Timestamp | undefined): number {
    return helpers.delta(finishDate)
  }

  public priceCourseWork (order: XvOrdersResp_Order): string {
    const size = this.size(order.size)

    let price = 0
    let priceFrom = false

    if (size <= 30) {
      price = 5000
    } else if (size > 30) {
      price = 6000
      priceFrom = true
    }

    const delta = this.delta(order.finishDate)

    // Also change this in xvostov accept calculator
    // And in xvostov api
    if (delta <= 2) {
      price += 1000
    } else if (delta <= 4) {
      price += 500
    }

    let res = price.toString()
    if (priceFrom) {
      res = 'от ' + res
    }

    return res
  }

  public priceCourseWorkPractice (order: XvOrdersResp_Order): string {
    const size = this.size(order.size)

    let price = 0
    let priceFrom = false

    if (size <= 35) {
      price = 6000
    } else if (size > 35) {
      price = 7000
      priceFrom = true
    }

    const delta = this.delta(order.finishDate)

    // Also change this in xvostov accept calculator
    // And in xvostov api
    if (delta <= 2) {
      price += 1500
    } else if (delta <= 4) {
      price += 1000
    }

    let res = price.toString()
    if (priceFrom) {
      res = 'от ' + res
    }

    return res
  }

  public priceCourseWorkPsycho (order: XvOrdersResp_Order): string {
    const size = this.size(order.size)

    let price = 0
    let priceFrom = false

    if (size <= 40) {
      price = 7000
    } else if (size > 40) {
      price = 8000
      priceFrom = true
    }

    const delta = this.delta(order.finishDate)

    // Also change this in xvostov accept calculator
    // And in xvostov api
    if (delta <= 2) {
      price += 1500
    } else if (delta <= 4) {
      price += 1000
    }

    let res = price.toString()
    if (priceFrom) {
      res = 'от ' + res
    }

    return res
  }

  public priceCourseWorkTech (order: XvOrdersResp_Order): string {
    const size = this.size(order.size)

    let price = 0
    let priceFrom = false

    if (size <= 40) {
      price = 8000
    } else if (size > 40) {
      price = 9000
      priceFrom = true
    }

    const delta = this.delta(order.finishDate)

    // Also change this in xvostov accept calculator
    // And in xvostov api
    if (delta <= 2) {
      price += 2000
    } else if (delta <= 4) {
      price += 1500
    }

    let res = price.toString()
    if (priceFrom) {
      res = 'от ' + res
    }

    return res
  }

  public priceReview (order: XvOrdersResp_Order): string {
    const size = this.size(order.size)

    let price = 0
    let priceFrom = false

    if (size < 15) {
      price = 3000
    } else if (size <= 25) {
      price = 4000
    } else if (size > 25) {
      price = 5000
      priceFrom = true
    }

    const delta = this.delta(order.finishDate)

    // Also change this in xvostov accept calculator
    // And in xvostov api
    if (delta <= 3) {
      price += 500
    }

    let res = price.toString()
    if (priceFrom) {
      res = 'от ' + res
    }

    return res
  }

  public priceTheses (order: XvOrdersResp_Order): string {
    const size = this.size(order.size)

    let price = 0
    let priceFrom = false

    if (size <= 60) {
      price = 30000
    } else if (size <= 90) {
      price = 35000
    } else if (size >= 90) {
      price = 38000
      priceFrom = true
    }

    const delta = this.delta(order.finishDate)

    // Also change this in xvostov accept calculator
    // And in xvostov api
    if (delta <= 4) {
      price += 3000
    } else if (delta <= 10) {
      price += 2000
    }

    let res = price.toString()
    if (priceFrom) {
      res = 'от ' + res
    }

    return res
  }
}
